/* unplugin-vue-components disabled */import script from "./BookingPatternSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingPatternSelector.vue?vue&type=script&setup=true&lang=js"

import "./BookingPatternSelector.vue?vue&type=style&index=0&id=b35280ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b35280ae"]])

export default __exports__